import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';

const ApprovalTypeLevelListItemComponent = ({ item, onEdit, onDelete, index }) => {
  const { t } = useTranslation();
  const handleDeleteItem = () => {
    if (window.confirm(t('ApprovalTypes.DeleteApprovalType'))) {
      onDelete(item.approvalTypeId, item.approvalTypeLevelId, index);
    }
  };

  const handleEditItem = () => {
    onEdit(item.approvalTypeLevelId);
  };

  return (
    <TableRow>
      <TableCell>{item.orderId}</TableCell>
      <TableCell>{item.levelName}</TableCell>
      <TableCell>{item.defaultEmployeeName}</TableCell>
      <TableCell align='right'>
        <IconButton
          type='edit'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.ApprovalTypeLevel.Edit')}
          onClick={handleEditItem}
        />
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.ApprovalTypeLevel.Edit')}
          onClick={handleDeleteItem}
        />
      </TableCell>
    </TableRow>
  );
};

ApprovalTypeLevelListItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default ApprovalTypeLevelListItemComponent;
